define(function (require) {
	const Marionette = require('backbone.marionette');
	const QuestionItemView = require('./v_itv_login_question');
	const tpl = require('./templates/t_lov_login_question.hbs');

	return Marionette.LayoutView.extend({
		template: tpl,
		regions: {
			QuestionItemViewRegion: '#questionItemView',
		},
		initialize: function (options) {
			this.config = options.config;
			this.modalContainer = options.modalContainer;
		},
		onRender: function () {
		},
		onShow: function () {
			var questionItemView = new QuestionItemView({
				config: this.config,
				modalContainer:this.modalContainer
			});
			this.QuestionItemViewRegion.show(questionItemView);
		},
		templateHelpers: function () {
			return {};
		},
	});
});
